import { Icon } from "components";
import { useLocation, Link } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger } from "ui/components/tabs";
import { cn } from "utils/index";

export default function NavSlot({ navItems, defaultTab = 0 }) {
  const { pathname } = useLocation();

  const activeTab =
    navItems.find((item) => pathname === item.path) || navItems[defaultTab];

  return (
    <Tabs value={activeTab.id.toString()}>
      <TabsList className="h-10">
        {navItems.map((item) => {
          return (
            <TabsTrigger
              key={item.id}
              value={item.id.toString()}
              className="min-w-11"
              asChild
            >
              <Link
                to={item.path}
                className={cn(
                  "px-3",
                  activeTab.id !== item.id && "text-muted-foreground"
                )}
              >
                {item.icon ? <Icon icon={item.icon} /> : item.label}
              </Link>
            </TabsTrigger>
          );
        })}
      </TabsList>
    </Tabs>
  );
}
